import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { NewslettersState } from "./types";
import { RootState } from "../types";

const namespaced: boolean = true;

export const newsletters: Module<NewslettersState, RootState> = {
    namespaced,
    //state,
    getters,
    actions,
    mutations,
};
